import React from 'react';
import { Link } from 'react-router-dom';
import { Clock, Calendar } from 'lucide-react';

const StoryCard = ({ story }) => {
  const formattedDate = new Date(story.date).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });

  return (
    <article className="group border-b border-gray-200 pb-8 mb-8 last:border-b-0">
      <Link to={`/${story.category}/${story.id}`} className="block">
        <h2 className="text-2xl font-serif text-gray-900 mb-3 group-hover:text-gray-600 transition-colors duration-200">
          {story.title}
        </h2>
      </Link>
      
      <div className="flex items-center gap-4 text-sm text-gray-500 mb-3">
        <span className="flex items-center gap-1">
          <Calendar size={14} />
          {formattedDate}
        </span>
        <span className="flex items-center gap-1">
          <Clock size={14} />
          {story.readTime}
        </span>
      </div>

      <p className="text-gray-700 leading-relaxed mb-4">
        {story.excerpt}
      </p>

      <Link
        to={`/${story.category}/${story.id}`}
        className="text-sm uppercase tracking-wider text-gray-900 hover:text-gray-600 transition-colors duration-200 inline-flex items-center gap-2 group"
      >
        Read
        <span className="transform group-hover:translate-x-1 transition-transform duration-200">→</span>
      </Link>
    </article>
  );
};

export default StoryCard;